import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'liberro-section-header',
  standalone: false,
  templateUrl: './liberro-section-header.component.html',
  styleUrl: './liberro-section-header.component.less'
})
export class LiberroSectionHeaderComponent {
  @Input() public showDescDivider = true;
  @Input() public showDescDividerMobile = false;
  @Input() public withoutDescription = false;
  @Input() public showBackBtn = false;
  @Input() public backButtonDataCy = '';
  @Input() public headerContentSmallMt = false;

  // todo - refactor route back, in 99% cases location.back should work
  // https://gitlab.com/dfcz/bwm-frontend/-/work_items/121
  @Output() public backBtnRouteClick = new EventEmitter<void>();

  public goBack(): void {
    this.backBtnRouteClick.emit();
  }
}
